// Config adapter: pure predicates for the assistant's surface/customer gating.
//
// Both the render gate (App) and the dynamic-ISQ decision (useMessageHistory)
// share this shape, but they derive "is this a mobile surface?" from different
// signals (breakpoint vs. experience `channel`). So these predicates take the
// resolved booleans explicitly rather than owning surface detection — each caller
// passes its own signal, and behaviour is unchanged.

/**
 * Is the assistant allowed for this customer type?
 * b2c always; b2b only when its flag is on.
 */
export const isCustomerTypeAllowed = (customerType, b2bEnabled) => (
  customerType === 'b2c' || (customerType === 'b2b' && b2bEnabled)
);

/**
 * Is the assistant enabled for the current surface, given the per-surface flags?
 * @param {Object} args
 * @param {boolean} args.isMobile      - mobile-sized surface (caller-resolved)
 * @param {boolean} args.isConsumerApp - running inside the consumer app
 * @param {boolean} args.dtEnabled     - desktop flag
 * @param {boolean} args.mwEnabled     - mobile-web flag
 * @param {boolean} args.appEnabled    - consumer-app flag
 */
export const isSurfaceEnabled = ({
  isMobile, isConsumerApp, dtEnabled, mwEnabled, appEnabled,
}) => (
  (dtEnabled && !isMobile)
  || (mwEnabled && isMobile && !isConsumerApp)
  || (appEnabled && isMobile && isConsumerApp)
);
